// Every Tailwind 500-shade hue. Stored as CSS variable names so the rendered
// gradient is `var(--color-rose-500)` etc. — which means swapping the project
// theme later automatically retones the logo.
export const COLOR_VARS = [
  "--color-red-500",
  "--color-orange-500",
  "--color-amber-500",
  "--color-yellow-500",
  "--color-lime-500",
  "--color-green-500",
  "--color-emerald-500",
  "--color-teal-500",
  "--color-cyan-500",
  "--color-sky-500",
  "--color-blue-500",
  "--color-indigo-500",
  "--color-violet-500",
  "--color-purple-500",
  "--color-fuchsia-500",
  "--color-pink-500",
  "--color-rose-500",
] as const;
